import { redirect } from '@rover/utilities/url';

import $ from '@rover/globals/jquery';
import _ from '@rover/globals/underscore';
import Backbone from '@rover/globals/backbone';
import Rover from '@rover/globals/Rover';

export default Backbone.Model.extend({
  // This 'model' is responsible for talking to the server
  // to get the results of a search query.  It also handles making
  // sure that only one search is run at a time.

  defaults: {
    query: null,
    searchResults: null,
  },

  initialize(options) {
    this.hasPets = options.hasPets;
    this.isSearching = false;
    this.searchToDo = false;

    // listen for enqueue search messages
    Rover.pubSub.on('search:enqueue', _.bind(this.enqueueSearch, this));

    // Refresh the results on query change
    this.get('query').on('change', _.bind(this.enqueueSearch, this));
  },

  enqueueSearch() {
    this.searchToDo = true;
    this.updateSearchResults();
  },

  successCallback(data) {
    if (data.redirect_url) {
      redirect(data.redirect_url);
      return;
    }

    if (data.errors) {
      Rover.pubSub.trigger('search:end', true);
      this.isSearching = false;
      return;
    }

    // Make sure we totally reset the searchResults object
    const searchResults = this.get('searchResults');
    searchResults.clear({ silent: true });
    searchResults.set(data);

    Rover.pubSub.trigger('search:end', true);
    this.isSearching = false;
    this.updateSearchResults();
  },

  errorCallback(data) {
    Rover.pubSub.trigger('search:end', false);
    this.isSearching = false;
    this.updateSearchResults();
  },

  getQueryParams() {
    // If the search has changed, always go back to
    // page 1
    const query = this.get('query');
    if (!query.changed.hasOwnProperty('page')) {
      query.set({ page: 1 }, { silent: true });
    }

    return this.postProcessParams(this.get('query').toJSON());
  },

  shouldSendSpacesRequired(params) {
    if (params.service_type === 'overnight-traveling') {
      return false;
    } else if (params.service_type === 'overnight-traveling') {
      return !this.hasPets;
    } else if (params.service_type === 'doggy-day-care') {
      return !this.hasPets;
    }
    return true;
  },

  postProcessParams(params) {
    if (!this.shouldSendSpacesRequired(params)) {
      delete params.spaces_required;
    }
    params.include_html = true;
    return params;
  },

  switchPitchExperimentPreSearch() {
    const query = this.get('query');
    const cookieName = Rover.context.switchPitchExperimentOverrideCookieName;
    const changed = query.changed.hasOwnProperty('service_type');
    const isBoarding = query.get('service_type') === 'overnight-boarding';
    const pitchWasSwitched = Rover.context.switchPitchExperimentPitchWasSwitched;
    const overrideCookieSet = $.cookie(cookieName) === 'holdout';

    if (changed && isBoarding && !overrideCookieSet) {
      $.cookie(cookieName, 'holdout', { expires: 1, path: '/' });
      query.unset('switch_pitch');
    } else if (pitchWasSwitched && !overrideCookieSet) {
      // If the context says we did arrived at the page with a switch
      // pitch, and it's not subsequently been overridden, then all other
      // queries from the frontend need to insert this to make sure the
      // callout displays
      query.set({ switch_pitch: true });
    }
  },

  preSearchHook() {
    this.switchPitchExperimentPreSearch();
  },

  updateSearchResults() {
    if (!this.searchToDo) {
      return;
    }

    // If there is a visible quick view then don't run this as it
    // will destroy the quick view but leave the modal (undismissible)
    if ($('.modal-body .sitter-quick-view').is(':visible')) {
      return;
    }

    if (!this.isSearching) {
      // Perform the search
      this.preSearchHook();
      const params = this.getQueryParams();
      this.isSearching = true;
      this.searchToDo = false;
      Rover.pubSub.trigger('search:start', params, this.get('query').changed);
      $.ajax({
        dataType: 'json',
        url: Rover.urls.search,
        data: $.param(params, true),
        traditional: true,
        success: _.bind(this.successCallback, this),
        error: _.bind(this.errorCallback, this),
      });
    }
  },
});



// WEBPACK FOOTER //
// ./js/backbone/models/search/search_results_queue.js